import { envelope_type_enum, insulation_method_enum } from '@predium/enums';
import {
  defaultMap,
  EnvelopeRenovationTemplates,
  InsulationMaterial,
  InsulationMaterialTemplates,
  OtherEnvelopeTypes,
} from './actionCatalog/envelopeRenovationParameters';

export const EnvelopeTemplates: Record<OtherEnvelopeTypes, { [key in insulation_method_enum]?: InsulationMaterial[] }> =
  {
    ...EnvelopeRenovationTemplates,
    [envelope_type_enum.PITCHED_ROOF]: {
      ...EnvelopeRenovationTemplates[envelope_type_enum.PITCHED_ROOF],
      [insulation_method_enum.INSULATION_GRADIENT]: [
        {
          ...InsulationMaterialTemplates.EPS,
          insulation_thickness: 0.14,
          insulation_lambda: 0.035,
        },
        {
          ...InsulationMaterialTemplates.PUR_Hartschaum,
          insulation_thickness: 0.18,
          insulation_lambda: 0.025,
        },
      ],
    },
  };

export function getEnvelopeInsulationValues(
  envelopeType: keyof typeof defaultMap,
  insulationMethod: insulation_method_enum,
): InsulationMaterial | undefined {
  const materialName = defaultMap[envelopeType][insulationMethod];
  return EnvelopeTemplates[envelopeType][insulationMethod]?.find(
    (template: InsulationMaterial) => template.material_name === materialName,
  );
}
